<template>
    <div class="loader is-loading"></div>
</template>

<script>
    /**
     * In order to center loading spinner it needs to be placed in flex container "columns" with "is-centered" class.
     */
    export default {
        name: "loading-spinner2",
    };
</script>
